import DOMPurify from 'dompurify';
import { BASE_RD_ICON_PREFIX, IconID } from './icon-constants';

export function getIconPathFromIconID(iconId: IconID): string {
  return BASE_RD_ICON_PREFIX + iconId;
}

export async function appendSVGSprite(
  spritePath: string | null,
  testId = 'default-sprite',
  isAbsolute = false
) {
  if (!spritePath) {
    return;
  }
  // In case of a fetch mock, we don't want to
  // run this. As this will be the case in tests.
  if (typeof fetch === 'undefined' || (fetch as any).ponyfill || (fetch as any).Promise) {
    return;
  }
  if (spritePath.indexOf('http') === -1 && isAbsolute) {
    // eslint-disable-next-line no-param-reassign
    spritePath = `https://${spritePath}`;
  }
  const response = await fetch(spritePath);
  const text = await response.text();
  // eslint-disable-next-line
  document.body.insertAdjacentHTML(
    'afterbegin',
    DOMPurify.sanitize(`<div class="icon-sprite-container" data-testid=${testId}>${text}</div>`)
  );
}
